import { render } from "./DroppedOrders.vue?vue&type=template&id=36c6ee2b"
import script from "./DroppedOrders.vue?vue&type=script&lang=js"
export * from "./DroppedOrders.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__